import { Box, CircularProgress } from '@mui/material';

function LoadingPanel({
  isLoading,
  children,
}: {
  isLoading: boolean | any;
  children: React.ReactNode;
}) {
  return (
    <Box sx={{ position: 'relative', width: '100%', height: '100%' }}>
      {isLoading && (
        <Box
          sx={{
            position: 'absolute',
            top: 0,
            left: 0,
            width: '100%',
            height: '100%',
            background: 'rgba(255, 255, 255, 0.8)',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            zIndex: 10,
          }}
        >
          <CircularProgress />
        </Box>
      )}
      {children}
    </Box>
  );
}

export default LoadingPanel;
